<div
  (mouseenter)="collapseOpenSidenav()"
  (mouseleave)="collapseCloseSidenav()"
  [class.collapsed]="collapsed"
  [class.open]="collapsed && (collapsedOpen$ | async)"
  class="vex-sidenav flex flex-col"
  >
  <div class="vex-sidenav-toolbar__container">
    <div class="sidenav-toolbar flex-none flex items-center">
      <img [src]="imageUrl$ | async" alt="Logo" class="select-none flex-none h-[71%]" />
    </div>

    <div class="vex-sidenav-toolbar__divider"></div>
  </div>

  <vex-scrollbar class="flex-1 flex flex-col">
    <div class="pt-6 flex-1">
      @for (item of items$ | async; track trackByRoute($index, item)) {
        <vex-sidenav-item
          [item]="item"
          [level]="0"
        ></vex-sidenav-item>
      }

      @if (isAdmin) {
        <br />
        <vex-sidenav-item
        [item]="{
          type: 'link',
          label: 'Voltar ao Sistema',
          route: '',
          icon: 'mat:subdirectory_arrow_left',
          textoCard: '',
          textoCardLink: '',
        }"
          [level]="0"
          [linkRetornar]="true"
        ></vex-sidenav-item>
      }
    </div>
  </vex-scrollbar>
</div>
